import React from 'react';
import { Card, Typography } from 'antd';

const { Title } = Typography;

interface PageHeaderProps {
  icon?: React.ReactNode;
  title: string;
  subtitle?: string;
  style?: React.CSSProperties;
  extra?: React.ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  icon,
  title,
  subtitle,
  style,
  extra
}) => {
  return (
    <Card style={{ marginBottom: 24, ...style }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <Title level={2} style={{ margin: 0 }}>
            {icon} {title}
          </Title>
          {subtitle && (
            <Typography.Text type="secondary" style={{ marginTop: 8, display: 'block' }}>
              {subtitle}
            </Typography.Text>
          )}
        </div>
        {extra && <div>{extra}</div>}
      </div>
    </Card>
  );
};

export default PageHeader; 